module.exports = __webpack_public_path__ + "img/c-2.8a3bad69.png";